import { type TicketRewardType } from '../types/lottery';

const ticketRewardList: TicketRewardType[] = [
  'silverTicket',
  'goldTicket',
  'diamondTicket',
];

export { ticketRewardList };
